import gsap from "gsap";
import { isAuthor, isMobile } from "../../../js/utils";
import { animateObserver, animateWords, fadeIn, parallaxVerticalImages } from "../../../js/animations/animations";

(() => {
  const BRHRoomDetail = () => {
    const init = () => {
      if (!isMobile() && !isAuthor()) {
        const heroesHome = document.querySelectorAll(".brh-room-detail");
        if (heroesHome.length > 0) {
          heroesHome.forEach((element) => {
            const timeline = gsap.timeline({
              scrollTrigger: {
                trigger: ".brh-room-detail",
                toggleActions: "none none none none",
                start: "-5% center",
                end: "bottom center",
                scrub: true,
              },
            });
            const image = element.querySelectorAll(".cmp-image__image");
            image && timeline.add(parallaxVerticalImages({ classElement: image, startsY: -100, endsY: 100 }), 0);

            const appearances = gsap.timeline();

            const titles = element.querySelector(".brh-title__text--default.js-animate-words");
            titles && appearances.add(animateWords({ classElement: titles }), 0);

            const paragraphs = document.querySelectorAll(".js-room-detail-fadeIn");
            paragraphs?.length > 0 && appearances.add(fadeIn({ classElement: paragraphs, duration: 2 }), 0);
            image?.length > 0 && appearances.add(fadeIn({ classElement: image, duration: 2 }), 0);
            const roomDetailCards = document.querySelectorAll(".brh-room-detail-item");
            roomDetailCards?.length > 0 && appearances.add(fadeIn({ classElement: roomDetailCards, duration: 2 }), 0);

            appearances.duration(2);
            appearances.pause();

            animateObserver({ elementToObserve: element, animation: () => appearances, threshold: 0 });
          });
        }
      }
    };

    init();
  };

  document.addEventListener("DOMContentLoaded", BRHRoomDetail);
})();
